// ============================================================================
// SwitchGroup.jsx — Corelia UI v1.2
// Groupe de switches cohérent avec l'écosystème FormLayout
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import Switch from "./Switch";

const SwitchGroup = ({
  options = [],              // [{ value, label, enabled }]
  onChange,                 // (name, newValue) => {}
  orientation = "vertical", // "vertical" | "horizontal"
  disabled = false,
  size = "small",
  showText = true,
  style = {},
  switchStyle = {},
  width = "100%",
}) => {

  const isHorizontal = orientation === "horizontal";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isHorizontal ? "row" : "column",
        alignItems: isHorizontal ? "center" : "flex-start",
        justifyContent: "flex-start",

        width,
        gap: isHorizontal ? theme.spacing.lg : theme.spacing.md,

        // Accessibilité & lisibilité
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "default",

        fontFamily: theme.form.label.fontFamily,
        marginBottom: theme.spacing.md,

        // Garantit une mise en page stable même si de nombreux switches
        flexWrap: isHorizontal ? "wrap" : "nowrap",
        whiteSpace: isHorizontal ? "nowrap" : "normal",

        ...style,
      }}
    >
      {options.map((opt, index) => (
        <div
          key={opt.value ?? index}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            width: isHorizontal ? "auto" : "100%",

            marginBottom:
              !isHorizontal && index < options.length - 1
                ? theme.spacing.xs
                : 0,

            fontFamily: theme.form.label.fontFamily,
            fontSize: theme.form.label.fontSize,
            color: theme.form.label.color,
            whiteSpace: "nowrap",
            gap: theme.spacing.md,
          }}
        >
          {/* Label du switch */}
          <span style={{ userSelect: "none" }}>
            {opt.label}
          </span>

          {/* Switch lui-même */}
          <Switch
            enabled={opt.enabled}
            onChange={(state) =>
              !disabled && onChange(opt.value, state)
            }
            size={size}
            showText={showText}
            label=""
            style={{ margin: 0 }}
            switchStyle={switchStyle}
          />
        </div>
      ))}
    </div>
  );
};

export default SwitchGroup;
